<template lang="html">
    <autonome-home v-if="autonomeDashboard"></autonome-home>
    <default-home v-else></default-home>
</template>

<script>
import AutonomeHome from './AutonomeHome.vue';
import DefaultHome from './DefaultHome.vue';

export default {
    name: 'Home',
    components: {
        AutonomeHome,
        DefaultHome
    },
    computed: {
        autonomeDashboard() {
            return window.config.autonome_motor_select
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/page/Home/Home.vue